import React from 'react';
import { useAuditorBranchesData } from '../hooks/useAuditorBranchesData';
import { Box, Flex, Spinner, Text } from '@chakra-ui/react';
import { PaginatorFooter } from '../../../components/PaginatorFooter';
import { BranchCard } from './BranchCard';
import { BranchFilters } from './BranchFilters';

export const BranchesTab = () => {
  const { data, error, loading, prevPage, nextPage, setParam, queryParams, search } = useAuditorBranchesData();

  return (
    <Flex direction="column" height="100%">
      <BranchFilters onUpdateFilters={search} queryParams={queryParams} />

      {loading && <Flex justifyContent="center" width="100%"><Spinner /></Flex>}
      {!!error && <>Error cargando los datos</>}

      {data && !data.total_elements && !loading &&
        <Text textAlign="center" width="full" color="neutral.600">
          No se encuentran sucursales asignadas a los criterios de búsqueda.
        </Text>
      }

      {!!data?.total_elements && !loading &&
        <>
          <Box flexGrow="1" marginBottom="xl" overflowY="auto" paddingX="xl">
            {data.content.map(branch => <BranchCard key={branch.id} branch={branch} marginBottom="xl" />)}
          </Box>

          <Box marginTop="auto" position="sticky" bottom="0">
            <PaginatorFooter
              pageable={data.pageable}
              total_elements={data.total_elements}
              onPreviousPage={prevPage}
              onNextPage={nextPage} />
          </Box>
        </>
      }
    </ Flex>);
};
